export const CATEGORY = 1;
export const FILE = 2;
export const LINK = 3;

export default Object.freeze({
  CATEGORY,
  FILE,
  LINK
});
